'use strict';

var _defineProperty = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/getPrototypeOf");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Container = require('./container');
var LazyResult, Processor;
var Document = /*#__PURE__*/function (_Container) {
  _inherits(Document, _Container);
  var _super = _createSuper(Document);
  function Document(defaults) {
    var _this;
    _classCallCheck(this, Document);
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    _this = _super.call(this, _objectSpread({
      type: 'document'
    }, defaults));
    if (!_this.nodes) {
      _this.nodes = [];
    }
    return _this;
  }
  _createClass(Document, [{
    key: "toResult",
    value: function toResult() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var lazy = new LazyResult(new Processor(), this, opts);
      return lazy.stringify();
    }
  }]);
  return Document;
}(Container);
Document.registerLazyResult = function (dependant) {
  LazyResult = dependant;
};
Document.registerProcessor = function (dependant) {
  Processor = dependant;
};
module.exports = Document;
Document.default = Document;